export const COACHING_BRAND = "Accompagnement Liberté LEASE";
export const COACHING_NAME = "Liberté LEASE";